module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add-notes":"Add notes to your contacts, and organize them with #hashtags.","hashtags":"Hashtags"},"fr":{"add-notes":"Ajoutez des notes à vos contacts, et organisez les avec des #hashtags.","hashtags":"Hashtags"}}')
  delete Component.options._Ctor
}
